// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("wedobooks" + "." + "29794d679aa3e5c82294" + ".js");